// extracted by mini-css-extract-plugin
export var bodyFont = "index-module--body-font--cI7eW";
export var borderRadius = "index-module--border-radius--2RUtm";
export var clearButtonStyles = "index-module--clear-button-styles--7W-fu";
export var price = "index-module--price--GP6tH";
export var summary_list = "index-module--summary_list--ZNlME";
export var titleFont = "index-module--title-font--lZqLv";